export { consts as modifierConsts } from './modifiers';
export * from './delivery';
export * from './order';
export * from './entitiesLimitations';
export * from './dataExtensions';
export const APP_DEF_IDS = {
  orders: '9a5d83fd-8570-482e-81ab-cfa88942ee60',
  menus: 'b278a256-2757-4f19-9313-c05c783bec92',
  reservations: 'f9c07de2-5341-40c6-b096-8eb39de391fb',
  restaurants: '9142e27e-2e30-4948-ad8f-7e128939efc4',
  orderTracker: 'e329a4ab-e1b2-4268-9cc6-ac6f77ec6767',
  tips: '869a50c8-dd38-4324-b201-e33dc0747a5f'
};
//# sourceMappingURL=index.js.map